export default "__VITE_ASSET__NA8SlVHz__"